/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ActionConstraintType = core.serialization.enum_(["hasAllValid", "hasSelection", "hasData", "hasColumnEnabled"]);
